import React, { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { CustomTable } from "@components/custom-table/table";
import { resetDelete } from "@helpers/custom-delete/controller/delete-slice";
import { url } from "@constants/url-constants";
import DeleteModal from "@components/custom-table/DeleteModal";
import PublishModel from "@components/custom-table/PublishModel";
import { resetPublish } from "../../publish/controller/publish.slice";
import { S3_BASE_URL } from "@constants/constants";
import { getMediaList } from "../services/media-services";
import {
  resetError,
  resetState,
  resetSuccess,
} from "../controller/media-slice";
import { getMediumType } from "../../../helpers/helpers";
import { MEDIA_CREATE_ID, MEDIA_DELETE_ID, MEDIA_PUBLISH_ID, MEDIA_UNPUBLISH_ID, MEDIA_UPDATE_ID } from "../../../helpers/permission/constant-permissions";
import { STORAGE_KEY } from "../../../constants/constants";
export const Medias = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const medias = useSelector((state) => state.media.medias);
  const pagination = useSelector((state) => state.media.pagination);
  const isLoading = useSelector((state) => state.media.loading);
  const responseMessage = useSelector((state) => state.media.responseMessage);
  const publishMessage = useSelector((state) => state.publish.responseMessage);
  const successMessage = useSelector((state) => state.media.successMessage);
  const deleteMessage = useSelector((state) => state.delete.successMessage);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageQuery = parseInt(searchParams.get("current_page"));
  const contentPage = parseInt(searchParams.get("content_page")) || 1;
  const currentPage = pagination?.current_page;
  const deleteUrl = url.mediums;
  const [deleteModel, setDeleteModel] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [publishModel, setPublishModel] = useState(false);
  const [publishData, setPublishData] = useState({});

  const userData = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));
  useEffect(() => {
    if (responseMessage !== null) {
      dispatch(resetState());
    }
  }, [dispatch, responseMessage]);

  useEffect(() => {
    if (publishMessage !== null) {
      toast.success(publishMessage);
      dispatch(resetPublish());
    }
  }, [dispatch, publishMessage]);

  useEffect(() => {
    if (deleteMessage !== null) {
      toast.success(deleteMessage);
      dispatch(resetDelete());
    }
  }, [dispatch, deleteMessage]);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success(successMessage);
      dispatch(resetSuccess());
    }
  }, [dispatch, successMessage]);

  const handleDeleteMedia = ({ id, url, deleted_at }) => {
    setDeleteModel(true);
    setDeleteData({ id, url, deleted_at });
  };

  const handlePublish = ({ id, type, published_at }) => {
    setPublishModel(true);
    setPublishData({ id, type, published_at });
  };

  const handleCreatePost = () => {
    navigate(`/medias/add`);
    dispatch(resetError());
  };

  const handleEditPost = ({ id, page, content }) => {
    navigate(`/medias/edit/${id}?current_page=${page}&&content_page=${content}`);
    dispatch(resetError());
  };
  const handleViewContent = ({ id, isContent }) => {
    navigate(`/contents?id=${id}`);
  };

  const columns = useMemo(
    () => {
      const cols = [
        {
          header: "Sorting ",
          accessorKey: "sorting",
          enableColumnFilter: false,
          enableSorting: true,
        },
        {
          header: "Medias",
          accessorKey: "title",
          enableColumnFilter: false,
          enableSorting: true,
        },
        {
          header: "Type",
          accessorKey: "type",
          enableColumnFilter: false,
          enableSorting: true,
          cell: (cellProps) => {
            return getMediumType(cellProps.row.original.type);
          },
        },
        {
          header: "Image",
          accessorKey: "thumbnail",
          enableColumnFilter: false,
          enableSorting: true,
          cell: (cellProps) => {
            return cellProps.row.original?.thumbnail?.image_url ? (
              <img
                src={S3_BASE_URL + cellProps.row?.original?.thumbnail?.image_url}
                alt=""
                className="avatar-sm rounded-circle img-thumbnail "
              />
            ) : null;
          },
        },

      ]
      if (userData?.permission_ids?.includes(MEDIA_PUBLISH_ID) || userData?.permission_ids?.includes(MEDIA_UNPUBLISH_ID)) {
        cols.push({
          header: "Publish/Unpublish",
          enableColumnFilter: false,
          enableSorting: true,
          cell: (cellProps) => {
            return (
              <ul className="list-unstyled hstack gap-2  d-flex justify-content-center mb-0">
                <li
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="publish"
                >
                  <button
                    className={
                      !cellProps.row.original.published_at
                        ? "btn btn-sm btn-success"
                        : "btn btn-sm btn-secondary"
                    }
                    disabled={(!userData?.permission_ids?.includes(MEDIA_PUBLISH_ID) && !cellProps.row.original.published_at) || (!userData?.permission_ids?.includes(MEDIA_UNPUBLISH_ID) && cellProps.row.original.published_at)}

                    onClick={() => {
                      if (cellProps.row.original.deleted_at === null) {
                        handlePublish({
                          id: cellProps.row.original._id,
                          page: currentPage,
                          published_at: cellProps.row.original.published_at,
                          type: cellProps.row.original.type,
                        });
                      } else {
                        toast.error("Record Not Found");
                      }
                    }}
                  >
                    {!cellProps.row.original.published_at
                      ? " Publish "
                      : "Unpublish"}
                  </button>
                </li>
              </ul>
            );
          },
        },)
      }
      if (userData?.permission_ids?.includes(MEDIA_DELETE_ID) || userData?.permission_ids?.includes(MEDIA_UPDATE_ID)) {
        cols.push({
          header: "Action",
          enableColumnFilter: false,
          enableSorting: true,
          cell: (cellProps) => {
            return (
              <ul className="list-unstyled hstack gap-2  d-flex justify-content-center mb-0">
                {userData?.permission_ids?.includes(MEDIA_UPDATE_ID) && (<li data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                  <button
                    className="btn btn-sm btn-soft-info"
                    onClick={() => {
                      if (cellProps.row.original.deleted_at === null) {
                        handleEditPost({
                          id: cellProps.row.original._id,
                          page: currentPage,
                          content: contentPage
                        });
                      } else {
                        toast.error("Record Not found");
                      }
                    }}
                    id={`edit-tooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-pencil" />
                  </button>
                </li>)}

                {userData?.permission_ids?.includes(MEDIA_DELETE_ID) && (<li
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={
                    cellProps.row.original.deleted_at === null
                      ? "Delete"
                      : "Restore"
                  }
                >
                  <button
                    className={`btn btn-sm ${cellProps.row.original.deleted_at == null
                      ? "btn btn-sm btn-soft-danger"
                      : "btn-soft-success"
                      }`}
                    // onClick={() => dispatch(deleteCountry(cellProps.row.original._id))}
                    onClick={() =>
                      handleDeleteMedia({
                        id: cellProps.row.original._id,
                        url: deleteUrl,
                        deleted_at: cellProps.row.original.deleted_at,
                      })
                    }
                    id={`delete-tooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-delete-outline" />
                  </button>
                </li>)}
              </ul>
            );
          },
        },)
      }
      console.log(cols, "userDatauserData");

      return cols
    },
    [currentPage, deleteUrl, userData]
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModel}
        onDeleteClick={handleDeleteMedia}
        onCloseClick={() => setDeleteModel(false)}
        data={deleteData}
      />
      <PublishModel
        show={publishModel}
        field="media"
        onPublishClick={handlePublish}
        onCloseClick={() => setPublishModel(false)}
        data={publishData}
      />
      <div className="page-content">
        <ToastContainer autoClose={2000} />
        <div className="container-fluid">
          {
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="">
                    <div className="d-flex align-items-center text-start">
                      <h5 className="mb-0 card-title flex-grow-1">
                        Media List
                      </h5>
                    </div>
                  </CardBody>
                  <CardBody>
                    <CustomTable
                      loading={isLoading}
                      columns={columns}
                      data={medias || []}
                      isCustomPageSize={true}
                      isGlobalFilter={true}
                      isJobListGlobalFilter={true}
                      isPagination={true}
                      isAddButton={true}
                      isAddPermission={userData?.permission_ids?.includes(MEDIA_CREATE_ID)}
                      page={currentPage}
                      isEpisode={false}
                      paginationCount={pagination?.total_count}
                      handleUserClick={handleCreatePost}
                      handleList={getMediaList}
                      paginationLimit={pagination}
                      buttonClass="btn btn-success"
                      buttonName="Add"
                      theadClass="thead-light"
                      SearchPlaceholder="Search for ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </div>
      </div>
    </React.Fragment>
  );
};
